import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en';
import fr from './fr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en,
      fr
    },
    supportedLngs: ['en', 'fr'],
    nonExplicitSupportedLngs: true,
    // O primeiro acesso abre em frances. Depois, a escolha feita no botao
    // FR/EN fica salva neste navegador.
    fallbackLng: 'fr',
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'toutPropreLanguage',
      caches: ['localStorage']
    },
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (language) => {
  document.documentElement.lang = language.startsWith('fr') ? 'fr' : 'en';
});

document.documentElement.lang = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'fr';

export default i18n;
